module.exports = "<div class=\"modal-header\">\r\n     <h3 class=\"modal-title\" id=\"modal-title\">{{$ctrl.title}}</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  {{$ctrl.text}}\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n   <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\r\n   <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/modal/confirmModal.html
// module id = 125
// module chunks = 0